if (!customElements.get('recently-viewed')) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    hide() {
      this.closest('section').classList.add('hidden');
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(entries[0].target);

      const currentStorage = localStorage.getItem('recentlyViewed');
      if (!currentStorage) return this.hide();

      const fetchPromises = currentStorage
        .split(',')
        .filter((url) => url != window.location.pathname)
        .map((url) => fetchRecentlyViewedProduct(url));

      Promise.all(fetchPromises)
        .then((dataArray) => {
          if (!dataArray) return this.hide();

          const fragment = new DocumentFragment();

          dataArray.forEach((item) => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');
            slide.innerHTML = item;

            fragment.appendChild(slide);
          });

          this.querySelector('[js-target]').appendChild(fragment);

          this.dispatchEvent(
            new CustomEvent('featured-collection-slider:init', {
              bubbles: true,
            }),
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }

    connectedCallback() {
      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: '0px 0px 200px 0px',
        },
      ).observe(this.closest('section'));
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
}
